// Copyright (c) 2018 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export default `hex_id,value
89283082c2fffff,64
8928308288fffff,73
89283082c07ffff,65
89283082817ffff,74
89283082c3bffff,66
89283082883ffff,76
89283082c03ffff,60
89283082807ffff,68
8928308289bffff,49
89283082c0fffff,41
89283082c87ffff,50
89283082d4fffff,45
89283082c77ffff,41
89283082c2bffff,53
89283082803ffff,41
89283082813ffff,43
89283082d5bffff,45
89283082897ffff,40
89283082c67ffff,42
89283082d47ffff,51
89283082dc3ffff,52
89283082c33ffff,43
89283082c23ffff,40
89283082887ffff,36
89283082d4bffff,36
892830828bbffff,48
892830828b7ffff,28
89283082c17ffff,34
89283082c6fffff,21
8928308288bffff,25
892830828abffff,26
89283082c27ffff,27
89283082c8fffff,33
89283082cafffff,29
89283082c13ffff,27
89283082cabffff,22
89283082c63ffff,26
89283082d43ffff,30
89283082d53ffff,19
892830828a3ffff,28
89283082d1bffff,20
89283095367ffff,17
8928309536bffff,26
89283082c37ffff,16
89283082c73ffff,17
89283082c8bffff,15
89283082ca7ffff,27
89283082cb3ffff,32
89283082c0bffff,26
89283082ca3ffff,19
89283082dcfffff,18
89283082c1bffff,20
89283082ddbffff,18
8928309534fffff,16
89283082d03ffff,15
89283082cbbffff,21
89283082cd7ffff,9
8928309534bffff,9
892830828c7ffff,13
89283082cc7ffff,12
89283082d0bffff,19
89283082dcbffff,19
89283082dd3ffff,15
89283082dd7ffff,15
892830828d7ffff,13
89283082d17ffff,5
8928309536fffff,8
89283095373ffff,6
89283082cb7ffff,15
89283082d83ffff,9
89283082d07ffff,4
89283082d0fffff,3
89283082d13ffff,6
89283082d9bffff,5
89283082c83ffff,11
89283082d8bffff,4
89283082dc7ffff,5
89283095377ffff,5
89283082c97ffff,4
89283082d7bffff,2
89283082d8fffff,1
89283095347ffff,3
89283095363ffff,2
8928309537bffff,4
89283082d93ffff,6
89283082d73ffff,1
8928309530bffff,1
8928309532bffff,1`;



// WEBPACK FOOTER //
// ./src/data/sample-hex-id-csv.js